import { Breadcrumb } from 'antd'
import React from 'react'
import GalleryTabs from './GalleryTabs'

const Gallery: React.FC = () => {
  const [breadcrumb, setBreadcrumb] = React.useState("Banner")
  return (
    <div className='mb-6'>
       <h1 className='text-xl sm:text-3xl font-semibold sm:b-1'>Gallery</h1>
       <div className='mb-4'>
         <Breadcrumb
          separator=">"
          items={[{title:"Gallery"},{title:breadcrumb}]}
         />
       </div>
       <GalleryTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  )
}

export default Gallery